// extracted by mini-css-extract-plugin
module.exports = {"linkResultats":"mostraMesResultats_linkResultats___8doJ"};